import FilterChip from 'LuxKit/Chips/FilterChip'
import type { OfferPagePriceMode } from 'contexts/OfferPage/offerPageStateReducer'
import { OfferPageActions, offerPagePriceModeLabel, offerPagePriceModes } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import useToggle from 'hooks/useToggle'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { useRef } from 'react'

interface Props {
  priceMode: OfferPagePriceMode
}

function PriceModeSelectMobile({ priceMode }: Props) {
  const { value: isOpen, toggle, off: close } = useToggle()
  const anchorRef = useRef<HTMLButtonElement>(null)
  const dispatch = useOfferPageDispatch()

  const setMode = (newMode: OfferPagePriceMode) => {
    dispatch({ type: OfferPageActions.setPriceMode, priceMode: newMode })
    close()
  }

  return <>
    <FilterChip size="medium" endIcon={<LineAngleDownIcon />} onClick={toggle} ref={anchorRef}>
      {offerPagePriceModeLabel[priceMode]}
    </FilterChip>
    <DropdownList size="S" open={isOpen} onClose={close} anchorRef={anchorRef} triggerRef={anchorRef} placement="bottom-end">
      {offerPagePriceModes.map(mode => <ClickableListItem key={mode} title={offerPagePriceModeLabel[mode]} onClick={() => setMode(mode)} />)}
    </DropdownList>
  </>
}

type MappedProps = Pick<Props, 'priceMode'>

export default withOfferPageState((state): MappedProps => ({
  priceMode: state.priceMode,
}), PriceModeSelectMobile)
